/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Roll_Up_3Inputs */

const en_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const fr_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déroulant 3`)
};

const de_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const it_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const ru_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const es_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const zh_cn2_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-Up 3`)
};

const ja_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールアップ3`)
};

const hi_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोल-अप 3`)
};

const pt_pt2_input_caption_style_roll_up_3 = /** @type {(inputs: Input_Caption_Style_Roll_Up_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enrole 3`)
};

/**
* | output |
* | --- |
* | "Roll-Up 3" |
*
* @param {Input_Caption_Style_Roll_Up_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_roll_up_3 = /** @type {((inputs?: Input_Caption_Style_Roll_Up_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Roll_Up_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_caption_style_roll_up_3(inputs)
	if (locale === "de") return de_input_caption_style_roll_up_3(inputs)
	if (locale === "it") return it_input_caption_style_roll_up_3(inputs)
	if (locale === "ru") return ru_input_caption_style_roll_up_3(inputs)
	if (locale === "es") return es_input_caption_style_roll_up_3(inputs)
	if (locale === "zh-CN") return zh_cn2_input_caption_style_roll_up_3(inputs)
	if (locale === "ja") return ja_input_caption_style_roll_up_3(inputs)
	if (locale === "hi") return hi_input_caption_style_roll_up_3(inputs)
	if (locale === "pt-PT") return pt_pt2_input_caption_style_roll_up_3(inputs)
	return en_input_caption_style_roll_up_3(inputs)
});